const initialState = {
  locations:[],
  location: null,
  users: null
}

export default function locations(state=initialState, action) {
  switch (action.type) {

    case 'FETCH_LOCATIONS':
      return {...state, locations: action.locations};

    case 'FETCH_LOCATION':
      return {...state, location: action.location}

    case 'FETCH_USERS':
      return {...state, users: action.users}

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/locations.js